export const ApiSettingsBookingTypes = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const save = async (payload) => {
    const result = await axios.post('/api/settings/booking-types/', payload)
    return result.data
  }

  const find = async (id) => {
    const result = await axios.get(`/api/settings/booking-types/${id}`)
    return result.data
  }

  const remove = async (id) => {
    const result = await axios.delete(`/api/settings/booking-types/${id}`)
    return result.data
  }

  const load = async () => {
    const result = await axios.get('/api/settings/booking-types')
    return result.data
  }

  return {
    bookingTypeFind: find,
    bookingTypeLoad: load,
    bookingTypeRemove: remove,
    bookingTypeSave: save
  }
}
